// src/components/AppIcon.jsx
import * as Lucide from "@/icons";

/**
 * Safe icon shim.
 * - If you pass `src`, it renders that IMAGE (use for brand/elephant only).
 * - Otherwise it renders a Lucide icon by `name`.
 * - If no `name` is provided, it falls back to a neutral HelpCircle,
 *   not the AfriMed elephant (prevents “logo everywhere”).
 */
export default function AppIcon({
  name,                 // e.g. "Mail", "Phone", "MapPin" (Lucide component names)
  size = 20,
  className = '',
  strokeWidth = 1.8,
  src,                  // pass only when you *really* want an image (brand/logo)
  alt = 'icon',
}) {
  if (src) {
    return (
      <img
        src={src}
        width={size}
        height={size}
        alt={alt}
        className={className}
        style={{ display: 'inline-block' }}
      />
    );
  }

  const Cmp = (name && Lucide[name]) || Lucide.HelpCircle;
  return <Cmp size={size} className={className} strokeWidth={strokeWidth} />;
}